import { useState, useEffect } from 'react'
import { Container } from '../Index/styles'
import Button from '../../../../components/Button'
import { api } from '../../../../services/api' 
import { Link } from 'react-router-dom'
import { useUserContext } from '../../../../components/contexts/useUserContext'
import Pagination from '../../../../components/Pagination';
import { Page } from "../../../AdminDashboard/styles"

const ClientManager = () => {
    const { user } = useUserContext()
    const [clients, setClients] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [showPermission, setShowPermission] = useState(false)

    useEffect(() => {
        api.get('/permissions/index')
        .then(response => {
          response.data.forEach((permission) => {
            if (permission.name === 'show_clients' && user.permissions.indexOf(permission.id) !== -1)
              setShowPermission(true)
          })
        })
      }, [user])

    useEffect(() => {
        window.scrollTo(0, 0)
        let offset = (currentPage - 1)*10
        api.get('clients/index/'+offset)
        .then((response) => {
            setClients(response.data)
        })
        api.get('clients/total_records/')
        .then((response) => {
          setTotalItems(response.data)
        })
      },[currentPage, user])

    return (
      <Page>
        <Container>
        <h1>Clientes</h1>
        <table>
            <thead>
            <tr>
                <th>Nome</th>
                <th>Email</th>
                <th>Opções</th>
            </tr>
            </thead>
            <tbody>
            {clients.map((client, index) => { return(
                <tr key={client.id}>
                <td>{client.name}</td>
                <td>{client.email}</td>
                <td className="buttons" style={{minWidth: "35%"}}>
                { showPermission &&   
                    <Link to={{ pathname: `clients/show/${client.id}`, state: { client }}}>
                        <Button className="info" format="show">Ver</Button>
                    </Link>
                }
                </td>
                </tr>
            )})}
            </tbody>
        </table>
        < div className = 'pagination-box'>
            <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={totalItems}
            pageSize={10}
            onPageChange={page => setCurrentPage(page)}
            />
        </ div>
        </Container>
      </Page>
    )
}

export default ClientManager